const NFO_ORDER_DETAIL = {
  pageDataAid: "orderPageSip",
  navigationHeader: {
    title: "NFO",
    dataAid: "nfoFundOrder",
  },
  investmentType: {
    title: {
      text: "Investment type",
      dataAid: "title",
    },
    sip: {
      text: "SIP",
      value: "sip",
      dataAid: "sip",
    },
    lumpsum: {
      text: "Lumpsum",
      value: "lumpsum",
      dataAid: "lumpsum",
    },
  },
  investmentCard: {
    sip: {
      amount: "SIP amount",
      date: "Monthly SIP date",
      placeHolder: "Enter amount",
      month: "th of every month",
    },
    lumpsum: {
      amount: "Lumpsum amount",
      placeHolder: "Enter amount",
    },
  },
  tnc: {
    dataAid: "termsCondition",
    leftText: "By tapping CONTINUE, I agree to have read the ",
    tncText: "Terms & Conditions",
  },
  footer: {
    text: "CONTINUE",
    dataAid: "primary",
  },
};

export default NFO_ORDER_DETAIL;
